import { z } from 'zod';

import { IdSchema, IsoDateSchema } from './common.js';
import { FoodSchema } from './foods.js';

export const TrackingModeSchema = z.enum(['nutrition', 'training']);
export type TrackingMode = z.infer<typeof TrackingModeSchema>;

export const TrackingModesSchema = z
  .array(TrackingModeSchema)
  .min(1)
  .max(2)
  .refine((modes) => new Set(modes).size === modes.length, 'tracking modes must be unique');

export const UpdateTrackingModesSchema = z.object({ modes: TrackingModesSchema }).strict();
export type UpdateTrackingModesInput = z.infer<typeof UpdateTrackingModesSchema>;

export const NutritionTargetSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  active: z.boolean(),
  calorieMin: z.number().int().positive(),
  calorieMax: z.number().int().positive(),
  proteinMinG: z.number().int().nonnegative(),
  proteinMaxG: z.number().int().nonnegative(),
  carbsMinG: z.number().int().nonnegative(),
  carbsMaxG: z.number().int().nonnegative(),
  fatMinG: z.number().int().nonnegative(),
  fatMaxG: z.number().int().nonnegative(),
  formulaVersion: z.string().min(1),
  sourceInputs: z.record(z.unknown()),
  createdAt: IsoDateSchema,
});
export type NutritionTarget = z.infer<typeof NutritionTargetSchema>;

export const NutritionTargetEnvelopeSchema = z.object({
  target: NutritionTargetSchema.nullable(),
});
export type NutritionTargetEnvelope = z.infer<typeof NutritionTargetEnvelopeSchema>;

export const FavoriteFoodSchema = z.object({
  id: IdSchema,
  foodId: z.string().min(1),
  createdAt: IsoDateSchema,
  food: FoodSchema,
});
export type FavoriteFood = z.infer<typeof FavoriteFoodSchema>;
export const FavoriteFoodsEnvelopeSchema = z.object({ items: z.array(FavoriteFoodSchema) });
export type FavoriteFoodsEnvelope = z.infer<typeof FavoriteFoodsEnvelopeSchema>;

export const RecentFoodSchema = z.object({
  food: FoodSchema,
  lastLoggedAt: IsoDateSchema,
  timesLogged: z.number().int().positive(),
});
export type RecentFood = z.infer<typeof RecentFoodSchema>;
export const RecentFoodsEnvelopeSchema = z.object({ items: z.array(RecentFoodSchema) });
export type RecentFoodsEnvelope = z.infer<typeof RecentFoodsEnvelopeSchema>;
